import React from "react";
import "./Privacypolicy.css";
import { Link } from "react-router-dom";

function Privacypolicy() {
  return (
    <div style={{ backgroundColor: "#51cada" }}>
      <div className="text-center pb-1 pt-3">
        <Link to="/">
          <img src="/assest/images/HomeImages/logo.png" alt="Privacypolicy" />
        </Link>
      </div>
      <div className="content">
        <div className="Practitionersbox">
          <h2 className="text-white text-center">
            Virtual Triage Terms & Conditions, Privacy Policy, Terms of Use, and
            Payment Guidelines for Healthcare Providers. (Practitioners)
          </h2>
          <h3 className="pt-3 pb-3">Terms & Conditions</h3>
          <hr />
          <h1 className="pt-3 pph1">Privacy Policy</h1>

          <ol>
            <li>
              <strong>Collection of Information:</strong> We collect various
              types of information from and about users of our Platform,
              including personal and health information.
            </li>

            <li>
              <strong>Use of Information:</strong> We use the information we
              collect to provide and improve our services, to communicate with
              you, to provide customer support, and for other business purposes.
            </li>

            <li>
              <strong>Disclosure of Information:</strong>We may disclose the
              information we collect to fulfill the purpose for which you
              provide it, for any other purpose we disclose when you provide the
              information, and for any other purpose with your consent.
            </li>
            <li>
              <strong>Data Security:</strong> We have implemented measures
              designed to secure your personal information from accidental loss
              and from unauthorized access, use, alteration, and disclosure.
            </li>
            <li>
              <strong>Changes to Our Privacy Policy:</strong>We will post any
              changes we make to our privacy policy on this page and notify you
              by email or through a notice on the Platform.
            </li>
          </ol>

          <h1 className="pph1">Terms of Use</h1>

          <ol>
            <li>
              <strong>Acceptance:</strong>By using the Virtual Triage platform
              ("Platform"), you agree to these Terms of Use, our Privacy Policy,
              and any documents they incorporate by reference.
            </li>
            <li>
              <strong>Access and Security:</strong>We reserve the right to
              withdraw or amend the Platform, and any service or material we
              provide, without notice. You are responsible for maintaining the
              security of your account.
            </li>
            <li>
              <strong>Intellectual Property:</strong>All content, features, and
              functionality of the Platform are owned by Virtual Triage and are
              protected by international intellectual property laws.
            </li>
            <li>
              <strong>Changes:</strong>We may revise and update these Terms of
              Use from time to time. Your continued use of the Platform
              following the posting of revised Terms of Use means you accept the
              changes.
            </li>
          </ol>

          <h1 className="pph1">Terms and Conditions</h1>

          <ol>
            <li>
              <strong>Introduction:</strong>These Terms & Conditions govern your
              use of the Virtual Triage platform ("the platform") as a
              healthcare provider ("you"). By using the platform, you accept
              these terms and conditions in full.
            </li>
            <li>
              <strong>Registration:</strong>You must be a licensed healthcare
              provider in your jurisdiction to use the platform. You agree to
              provide accurate, current, and complete information during the
              registration process and to update such information to keep it
              accurate, current, and complete.
            </li>
            <li>
              <strong>Use of the Platform:</strong>You agree to use the platform
              in a manner consistent with any and all applicable laws and
              regulations in your jurisdiction. You will not use the platform to
              post any material that is knowingly false and/or defamatory,
              inaccurate, abusive, vulgar, hateful, harassing, obscene, profane,
              sexually oriented, threatening, invasive of a person's privacy, or
              otherwise in violation of any law.
            </li>
            <li>
              <strong>Patient Confidentiality:</strong>You agree to maintain the
              confidentiality of all patient information in accordance with
              applicable laws and regulations, including but not limited to the
              Health Insurance Portability and Accountability Act (HIPAA) in the
              U.S., the Personal Information Protection and Electronic Documents
              Act (PIPEDA) in Canada, and the General Data Protection Regulation
              (GDPR) in the UK.
            </li>
            <li>
              <strong>Telemedicine Services:</strong>You understand that the
              platform is a telemedicine platform and agree to provide medical
              services to patients in a manner consistent with the standard of
              care for telemedicine in your jurisdiction.
            </li>
            <li>
              <strong>Indemnification:</strong>You agree to indemnify and hold
              harmless Virtual Triage, its officers, directors, employees,
              agents, and third parties, for any losses, costs, liabilities, and
              expenses (including reasonable attorney's fees) relating to or
              arising out of your use of or inability to use the platform, your
              violation of any terms of this Agreement or your violation of any
              rights of a third party, or your violation of any applicable laws,
              rules or regulations.
            </li>
            <li>
              <strong>Termination:</strong>Virtual Triage reserves the right to
              terminate your access to the platform at any time, for any reason,
              at its sole discretion.
            </li>
            <li>
              <strong>Changes to Terms & Conditions:</strong>Virtual Triage
              reserves the right to modify these Terms & Conditions at any time.
              We will inform you of any changes by posting the new Terms &
              Conditions on the platform. Your continued use of the platform
              after any such changes constitutes your acceptance of the new
              Terms & Conditions.
            </li>
            <li>
              <strong>Governing Law:</strong>These Terms & Conditions shall be
              governed by and construed in accordance with the laws of the
              country in which the healthcare provider is registered and
              practicing.
            </li>
            <li>
              <strong>Dispute Resolution:</strong>Any disputes arising out of or
              in connection with these Terms & Conditions shall be resolved
              through arbitration in the jurisdiction of the healthcare
              provider, unless otherwise required by the laws of that
              jurisdiction.
            </li>
          </ol>

          <h1 className="pph1">Payment Guidelines</h1>

        
          <ol>
            <li>
              <strong>Fees:</strong>The services of Virtual Triage are available on a subscription basis. The payment for the subscription is due on a monthly basis. The specific details of the subscription, including the cost and the services included in the subscription, will be provided to you at the time of subscription. All payments are to be made electronically. The subscription will automatically renew each month unless and until you cancel your subscription or the subscription is suspended or discontinued by Virtual Triage.
            </li>
           
          </ol>
         
        </div>
      </div>
      <hr />
      <div className="content">
        <div className="Practitionersbox">
          <h2 className="text-white text-center">
            Virtual Triage Terms & Conditions, Privacy Policy, Terms of Use, and
            Payment Guidelines for Healthcare Seekers. (Patients)
          </h2>
          <h3 className="pt-3 pb-3">Terms & Conditions</h3>
          <hr />
          <h1 className="pt-3 pph1">Privacy Policy</h1>

          <ol>
            <li>
              <strong>Introduction:</strong> Virtual Triage ("we", "us", "our") respects the privacy of its users ("you") and is committed to protecting it through our compliance with this policy.
            </li>

            <li>
              <strong>Information We Collect:</strong>We may collect several types of information from and about users of our application, including personal information, health information, and information about your internet connection, the equipment you use to access our application, and usage details.
            </li>

            <li>
              <strong>How We Use Your Information:</strong>We use information that we collect about you or that you provide to us, including any personal information, to provide you with information, products, or services that you request from us, to fulfill any other purpose for which you provide it, to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, and in any other way we may describe when you provide the information.
            </li>
            <li>
              <strong>Disclosure of Your Information:</strong>We may disclose aggregated information about our users, and information that does not identify any individual, without restriction. We may disclose personal information that we collect or you provide as described in this privacy policy.
            </li>
            <li>
              <strong>Your Rights:</strong>You have certain rights under applicable data protection laws, including the right to access and update your personal information, restrict how it is used, transfer certain personal information to another controller, withdraw your consent at any time, and the right to have us erase certain personal information about you.
            </li>
            <li>
              <strong>Changes to Our Privacy Policy:</strong>We will post any changes we make to our privacy policy on this page. If we make material changes to how we treat our users' personal information, we will notify you through a notice on the application home page.
            </li>
          </ol>

          <h1 className="pph1">Terms of Use</h1>

          <ol>
            <li>
              <strong>Acceptance of the Terms of Use:</strong>These terms of use are entered into by and between you and Virtual Triage. The following terms and conditions, together with any documents they expressly incorporate by reference, govern your access to and use of Virtual Triage, including any content, functionality, and services offered on or through Virtual Triage.
            </li>
            <li>
              <strong>Accessing the Application and Account Security:</strong>We reserve the right to withdraw or amend this application, and any service or material we provide on the application, in our sole discretion without notice.
            </li>
            <li>
              <strong>Intellectual Property Rights:</strong>The application and its entire contents, features, and functionality are owned by Virtual Triage, its licensors, or other providers of such material and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
            </li>
            <li>
              <strong>Prohibited Uses:</strong>You may use the application only for lawful purposes and in accordance with these Terms of Use.
            </li>
            <li>
              <strong>Changes to the Terms of Use:</strong>We may revise and update these Terms of Use from time to time in our sole discretion.
            </li>
          </ol>

          <h1 className="pph1">Terms and Conditions</h1>

          <ol>
            <li>
              <strong>Introduction:</strong>These Terms and Conditions govern your use of our application; by using our application, you accept these terms and conditions in full.
            </li>
            <li>
              <strong>License to Use Application:</strong>Unless otherwise stated, Virtual Triage owns the intellectual property rights in the application and material on the application.
            </li>
            <li>
              <strong>Acceptable Use:</strong>You must not use our application in any way that causes, or may cause, damage to the application or impairment of the availability or accessibility of the application; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
            </li>
            <li>
              <strong>User Content:</strong>In these terms and conditions, “your user content” means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to our application, for whatever purpose.
            </li>
            <li>
              <strong>No Warranties:</strong>This application is provided “as is” without any representations or warranties, express or implied.
            </li>
            <li>
              <strong>Limitations and Exclusions of Liability:</strong>Our liability to you in relation to the use of our application or under or in connection with these terms and conditions, whether in contract, tort (including negligence) or otherwise, will be limited as follows: Virtual Triage will not be liable for any consequential, indirect or special loss or damage; Virtual Triage will not be liable for any loss of profit, income, revenue, anticipated savings, contracts, business, goodwill, reputation, data, or information.
            </li>
            <li>
              <strong>Indemnity:</strong>You hereby indemnify Virtual Triage and undertake to keep Virtual Triage indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by Virtual Triage to a third party in settlement of a claim or dispute on the advice of Virtual Triage's legal advisers) incurred or suffered by Virtual Triage.
            </li>
            
          </ol>

          <h1 className="pph1">Payment Guidelines</h1>

          <ol>
            <li>
              <strong>Fees:</strong>You agree to pay all fees due for services
              provided through the Platform. Fees are subject to change at any
              time at our sole discretion.
            </li>
            <li>
              <strong>Billing:</strong> We use a third-party payment processor
              to bill you for services provided through the Platform. By
              choosing to use these services, you agree to pay us, through our
              payment processor, all charges at the prices then in effect for
              any use of such services in accordance with the applicable payment
              terms.
            </li>
            <li>
              <strong>Refunds:</strong>All payments are non-refundable except as
              required by law.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default Privacypolicy;
